import React from 'react';
import { NavLink, Link, withRouter } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOutAlt, faSignInAlt, faUsersCog, faHome, faUser } from '@fortawesome/free-solid-svg-icons';

// import AdminGroupSelect from 'Components/Partials/AdminGroupSelect';

import User from 'Services/User';
import { asset, filterItemsByAccess } from 'Services/BaseHelpers';
import AdminGroupSelect from "Components/Partials/AdminGroupSelect";
import ChatsApi from 'Services/Api/Networking/Chats';

class Header extends React.Component {
    /**
     * @var navItems
     * @type {string}
     */
    navItems = [
        // // Pre auth
        // {
        //     to: "/login",
        //     icon: faSignInAlt,
        //     title: "Login",
        //     is_logged_out: true
        // },
        // Post auth
        {
            to: "/welcome",
            title: "Welcome",
        },
        // {
        //     to: "/agenda",
        //     title: "Agenda",
        // },
        // {
        //     to: "/exhibitors",
        //     title: "Exhibitors",
        //     //is_logged_in: true
        // },
        // {
        //     to: "/attendees",
        //     title: "Attendees",
        //     is_logged_in: true
        // },
        // {
        //     to: "/networking",
        //     title: "Networking",
        //     is_logged_in: true
        // },
        {
            to: "/registration",
            title: "Registration",
        },
        // {
        //     to: "/contact-us",
        //     title: "Contact",
        // },
        // {
        //     to: "/information",
        //     title: "Information",
        // },
        // {
        //     to: "/about",
        //     title: "About Bupa",
        // },
        {
             to: "/information",
             title: "Information",
         },
        // {
        //     to: "/on-demand",
        //     title: "On Demand",
        //     is_logged_in: true
        // },
        // {
        //     to: "/speakers",
        //     title: "Speakers",
        //     is_logged_out: true
        // },
        {
            to: "/admin",
            icon: faUsersCog,
            title: "Admin",
            is_admin: true,
            is_logged_in: true
        },
        {
            to: "/logout",
            icon: faSignOutAlt,
            title: "Logout",
            is_logged_in: true
        },
    ];

    /**
     * @var state
     * @type {{showOnMobile: boolean}}
     */
    state = {
        showOnMobile: false,
        unreadCount: null,
    }

    componentDidMount() {
        this.fetchUnreadCount();
    }

    fetchUnreadCount = async () => {
        const response = await ChatsApi.getNumberUnread();
        if (response.success) {
            this.setState({
                unreadCount: response?.data?.number_unread ?? null
            });
        }
    }

    /**
     * @method render
     * @returns {JSX.Element}
     */
    render() {
        const { showOnMobile } = this.state;
        const { pageTitle, headerImage, titleText, pageVideoHeader = null } = this.props;

        return (
            <div className="flex flex-col bg-app-blue">

                <div className="flex items-center p-5 w-full bg-app-blue text-white mx-auto">
                    {/*<Link to="/" className={`${ !showOnMobile ? 'absolute top-5 left-5 lg:hidden' : 'hidden lg:flex' } flex-row justify-center items-center gap-2 font-bold`}>*/}
                    {/*    <img*/}
                    {/*        src={ asset ( 'images/logo.png' ) }*/}
                    {/*        alt="Logo"*/}
                    {/*        className="h-16 lg:h-20 mr-4"*/}
                    {/*    />*/}
                    {/*</Link>*/}
                    <div className={ `${ showOnMobile ? 'flex' : 'hidden lg:flex' } flex-col lg:items-end w-full` }>
                        <div className="w-full flex flex-col lg:flex-row justify-center items-center gap-4 lg:gap-8 text-center">
                            <div className={ `mx-auto w-full max-w-6xl flex flex-col lg:flex-row ${ filterItemsByAccess ( this.navItems ).length >= 6 ? 'justify-between gap-4' : 'gap-12 justify-center md:ml-auto' }` }>
                                { filterItemsByAccess ( this.navItems ).map ( ( navItem, i ) => this.renderNavItem ( navItem, i ) ) }
                                {/*{ User?.data?.is_admin && window.base.features.groups && <AdminGroupSelect /> }*/}
                            </div>
                            {/*{ User && User.loggedIn && (*/}
                            {/*    <div*/}
                            {/*        key={ "" }*/}
                            {/*        className="flex flex-row justify-center items-center gap-2 font-bold bg-app-light-blue"*/}
                            {/*    >*/}
                            {/*            <NavLink*/}
                            {/*                className="flex flex-row justify-center items-center gap-2 font-bold bg-app-light-blue px-6 py-2"*/}
                            {/*                activeClassName="border-b-2 border-app-primary"*/}
                            {/*                to={ "/main-stage" }*/}
                            {/*                exact={ true }*/}
                            {/*            >*/}
                            {/*                Live Stream*/}
                            {/*            </NavLink>*/}
                            {/*    </div>*/}
                            {/*)}*/}

                        </div>
                    </div>
                </div>

                <div
                    className="bg-app-blue text-white   select-none flex items-center flex-wrap lg:flex-nowrap"
                >
                    <div className=" flex flex-col lg:flex-row w-full justify-center  mx-auto gap-5">
                        <FontAwesomeIcon
                            icon={ faBars }
                            size="2x"
                            onClick={ () => this.setState ( { showOnMobile: !showOnMobile } ) }
                            className="block lg:hidden cursor-pointer ml-auto pb-2 mr-5"
                        />
                        {pageVideoHeader ? (
                            <div className="m-auto flex items-stretch w-screen">
                                <Link to="/">
                                    <video
                                        src={ asset ( 'images/' + pageVideoHeader ) }
                                        alt="video"
                                        className="m-auto min-w-0 h-full w-screen hidden lg:block"
                                        controls={ false }
                                        autoPlay
                                        muted={ true }
                                        controlsList="nodownload nofullscreen noremoteplayback"
                                        loop
                                        playsInline={ true }
                                    />
                                    <video
                                        src={ asset ( 'images/bupa-banner-mobile.mp4' ) }
                                        alt="video"
                                        className="m-auto min-w-0 h-full  w-full lg:hidden"
                                        controls={ false }
                                        autoPlay
                                        muted={ true }
                                        controlsList="nodownload nofullscreen noremoteplayback"
                                        loop
                                        playsInline={ true }
                                    />
                                </Link>
                            </div>
                        ) : (
                            <div className="w-full m-auto flex justify-center items-center">
                                { headerImage && (
                                    <div className="relative w-full h-auto">
                                        <img
                                            src={ asset ( headerImage ) }
                                            alt="Header"
                                            className="w-full h-auto"
                                        />
                                        { titleText && (
                                            <div className="absolute inset-0 flex items-center justify-center">
                                                <span className="text-white text-2xl md:text-7xl">{ titleText }</span>
                                            </div>
                                        ) }
                                    </div>
                                ) }
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }


    /**
     * @method renderNavItem
     * @param {object} navItem
     * @param {integer} key
     * @returns {JSX.Element}
     */
    renderNavItem = ( navItem, key ) => {
        const { unreadCount } = this.state;


        return (
            <div key={ key } className={'relative'}>
                <NavLink
                    className="flex flex-row justify-center items-center gap-2 font-bold"
                    activeClassName="border-b-2 border-app-primary"
                    to={ navItem.to }
                    exact={ true }
                >
                    { navItem.icon &&
                        <FontAwesomeIcon
                            icon={ navItem.icon }
                            size="1x"
                        />
                    }

                    { navItem.title }
                </NavLink>
                { unreadCount > 0 &&  navItem.to === '/networking' && (
                    <div className="absolute top-[-0.5rem] right-[-0.5rem] inline-block w-4 h-4 bg-red-600 rounded-full text-xs">{ unreadCount }</div> ) }
            </div>
        );
    };
}

export default withRouter ( Header );
